<template>

  <div id="app">
    <!-- <header>
      <span>Vue.js PWA</span>
    </header> -->

     <!-- <a href="javascript:void(0);" onclick="window.location.reload(true);"><img class="reload" src="static/img/reload.jpeg" alt="更新"></a> -->
    <main>
      <!-- <img src="./assets/logo.png" alt="Vue.js PWA">
      <router-view></router-view> -->
      <unity
        src="static/unityBuild/Build/unityBuild.json"
        v-bind="{
            width: gameWidth,
            height: gameHeight,
            hideFooter: true
         }"
         unityLoader="static/unityBuild/Build/UnityLoader.js"
       ></unity>
    </main>
  </div>
</template>

<script>
import unity from 'vue-unity-webgl'

export default {
  name: 'app',
  data: function () {
    return {
      gameWidth: window.innerWidth,
      gameHeight: window.innerHeight - 150//* 0.96 - 134 // 134はヘッダー等の値
    }
  },
  methods: {
    handleResize: function () {
      this.gameWidth = window.innerWidth
      this.gameHeight = window.innerHeight - 150
    }
  },
  // ready: function () {
  //   window.addEventListener('resize', this.handleResize)
  // },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  components: { unity }
}


</script>

<style>
body {
  margin: 0;
  background-color: black;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 90px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495E;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}
.reload {
  width: 40px;
  height: 40px;

  position: fixed;
  /*基準を画面の左上に*/
  top: 0;
  right: 0;

}
</style>



// WEBPACK FOOTER //
// src/App.vue